import LazyLoad from 'vanilla-lazyload';
import Cookies from 'js-cookie';
// import barba from '@barba/core';
// import gsap from 'gsap';
import Testimonials from "../components/testimonials";
import SliderImg from "../components/sliderImg";
import SkillSlider from "../components/skillSlider";
import ReferenceSlider from "../components/referenceSlider";
import TestimonySlider from "../components/testimonySlider";
import CardHover from "../components/cardHover";
import TeamSlider from "../components/teamSlider";
import Contact from "../components/contact";
import Video from "../components/video";
import Audio from "../components/audio";
import Anchors from "../components/anchors";
import Marquee from "../components/marquee";
import Modal from '../components/modal';
// import SplitText from '../vendor/gsap/SplitText';
import StickyButton from '../components/stickyButton';
import MobileMenu from '../components/mobileMenu';
import { jsonp } from '../utils/utils';
// import WebFont from "webfontloader";
// import mobile from 'is-mobile';
import Jump from 'jump.js'
import { easeInOutCubic } from 'ez.js';

class General {
  constructor() {
    // console.log("Hello World, made with love by Spiriit");
    window.wrapper = document.querySelector('.site');
    // if (barba.data && barba.data.next.container) {
    //   window.wrapper = barba.data.next.container;
    // }

    this.lazyLoadImages();
    this.headerScrollBehavior();
    this.bannerBehavior();
    this.animatedCursor();
    this.animatedArrow();
    this.stickyButtons();
    this.initMarquee();
    General.preventDefaultLinks();
    General.initSliderImg();
    General.initTestimonials();
    General.initSkillSlider();
    General.initReferenceSlider();
    General.initTestimonySlider();
    General.initCardHover();
    General.initTeamSlider();
    General.initVideo();
    General.initAudio();
    General.initModal();
    General.initAnchors();
    General.toggleCollapse();
    General.initMobileMenu();
    General.handleAnchors();
    General.initContact();
  }

  static scrollToSmooth(el, offset = 0) {
    const header = document.querySelector('.header');
    const headerHeight = header.clientHeight;
    const elPosition = el.getBoundingClientRect().top
    const position = elPosition - headerHeight + offset;
    Jump(position, {
      duration: 800,
      easing: easeInOutCubic
    });
  }

  static toggleCollapse() {
    const accs = window.wrapper.querySelectorAll('.collapse-js');

    [].forEach.call(accs, (element) => {
      element.addEventListener("click", function(ev) {
        ev.preventDefault();
        ev.stopPropagation();

        let target = this;

        if(ev.target.tagName !== 'A') {
          target = ev.target.closest('.collapse-js');
        }

        const panel = window.wrapper.querySelector(target.getAttribute("href"));

        if(target.classList.contains('active')){
          panel.style.maxHeight = `${panel.scrollHeight  }px`; // hack if already opened
          setTimeout(() => {
            panel.style.maxHeight = null;
          }, 10)
        } else {
          panel.style.maxHeight = `${panel.scrollHeight  }px`;
        }

        target.classList.toggle("active");
      });
    });
  }

  static initVideo() {
    return new Video();
  }

  static initAudio() {
    return new Audio();
  }

  static initModal() {
    return new Modal();
  }

  static initSliderImg() {
    return new SliderImg();
  }

  static initTestimonials() {
    return new Testimonials();
  }

  static initAnchors() {
    return new Anchors();
  }

  static initContact() {
    return new Contact();
  }

  initMarquee() {
    const marquees = window.wrapper.getElementsByClassName('js-marquee')
    Array.from(marquees).forEach((marquee) => {
      new Marquee(marquee)
    });
  }

  static initReferenceSlider() {
    return new ReferenceSlider();
  }

  static initSkillSlider() {
    return new SkillSlider();
  }

  static initTestimonySlider() {
    return new TestimonySlider();
  }

  static initCardHover() {
    return new CardHover();
  }

  static initTeamSlider() {
    return new TeamSlider();
  }

  static initMobileMenu() {
    return new MobileMenu();
  }

  static preventDefaultLinks() {
    [].forEach.call(window.wrapper.querySelectorAll('a.preventDefault'), (link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        return false;
      });
    });
  }

  static handleAnchors() {
    const anchors = document.querySelectorAll('a[href^=\\#]:not([href$=\\#]):not(.collapse-js):not(.no-smooth)');
    anchors.forEach((anchor) => {
      anchor.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const hashval = anchor.getAttribute('href');
        const target = document.querySelector(hashval);

        if (target) {
          General.scrollToSmooth(target);
        }
      })
    })
  }

  lazyLoadImages() {
    window.lazyLoad = new LazyLoad({
      elements_selector: '.lazy-image, [data-bg], [data-bg-multi], [data-srcset], [data-gist]',
      thresholds: '400px 50%',
      unobserve_entered: true,
      callback_enter(el){
        // if lazyload element is a gist
        if (el.classList.contains('wp-block-script')) {
          const url = el.getAttribute('data-gist');
          jsonp(url, (data) => {
            el.insertAdjacentHTML('beforeend', `<link href="${data.stylesheet}" rel="stylesheet">`);
            el.insertAdjacentHTML('beforeend',data.div);
          });
        }
      },
      callback_loaded(el) {
        el.parentNode.classList.add('loaded');
      }
    });
  }

  headerScrollBehavior() {
    let lastScrollTop = 0;
    const header = window.wrapper.querySelector('.js-fixed-header');
    const banner = window.wrapper.querySelector('.js-banner');
    if (!header) return;

    this.checkMenuState = () => {
      const delta = window.scrollY;

      if (window.wrapper.contains(banner)) {
        const bannerHeight = banner.clientHeight;
        if (delta > bannerHeight) {
          header.style.top = '';
          header.classList.add('is_stuck');
        } else {
          header.style.top = `${bannerHeight - delta}px`;
          header.classList.remove('is_stuck');
        }
      } else {
        if (delta > 5) {
          header.classList.add('is_stuck');
        } else {
          header.classList.remove('is_stuck');
        }
      }

      if (delta > lastScrollTop) {
        header.classList.remove('scrolling-up');
      } else {
        header.classList.add('scrolling-up');
      }

      if (delta <= 0) {
        header.classList.remove('scrolling-up');
      }

      lastScrollTop = delta;
    };
    this.checkMenuState();

    // change event to listen window event listener
    window.addEventListener('scroll', this.checkMenuState);
  }

  bannerBehavior() {
    const bannerClose = window.wrapper.querySelector('.js-banner-close');
    if (!bannerClose) return;

    bannerClose.addEventListener('click', () => {
      const header = window.wrapper.querySelector('.js-fixed-header');
      const banner = window.wrapper.querySelector('.js-banner');
      const bannerHash = banner.dataset.hash;
      banner.remove();

      // clean header (see above)
      header.classList.remove('header--banner');
      header.style.top = '';

      Cookies.set('hide-banner', bannerHash, { expires: 7 });
    })

    bannerClose.addEventListener('mouseenter', () => window.cursor.enter(false, false));
    bannerClose.addEventListener('mouseleave', () => window.cursor.leave());
  }

  animatedCursor() {
    const links = window.wrapper.querySelectorAll('a:not(.preventDefault), [class*="swiper-button-"]');
    [].forEach.call(links, (link) => {
      const posttype = link.dataset.type ? link.dataset.type : null;
      link.addEventListener('mouseenter', () => window.cursor.enter(posttype));
      link.addEventListener('mouseleave', () => window.cursor.leave(posttype));
    });
  }

  animatedArrow() {
    const links = window.wrapper.querySelectorAll('.link--arrow');
    [].forEach.call(links, (link) => {
      link.addEventListener('mouseenter', () => {
        if(link.classList.contains('play')){
          return;
        }
        link.classList.add('play');
        setTimeout(() => {
          link.classList.remove('play');
        }, 1000);
      });
    });
  }

  stickyButtons() {
    this.buttons = window.wrapper.querySelectorAll('.button--anim');
    if (this.buttons.length === 0) {
      return;
    }

    [].forEach.call(this.buttons, (button) => {
      return new StickyButton(button);
    });
  }

  removeListeners() {
    if (window.lazyLoad) {
      window.lazyLoad.destroy();
    }
  }
}

export default General;
